import throttle from '@/utils/throttle';

function adjust (el, binding) {
    const maxLines = binding.value;

    if (! maxLines) {
        // @TODO if maxlines was set before, we need to show all child elements we had hid before
        return;
    }

    for (const child of el.childNodes) {
        if (child instanceof window.Comment) {
            continue;
        }
        if (child instanceof window.Text) {
            child._origText = child._origText || child.textContent;
            child.textContent = '';
        } else {
            child.style.display = 'none';
        }
    }

    let lines = 0;
    let height = el.clientHeight;

    for (const child of el.childNodes) {
        if (child instanceof window.Comment) {
            continue;
        }
        if (child instanceof window.Text) {
            if (child._origText.length === 0) {
                child.textContent = '';
                continue;
            }

            let newText = '';
            for (let i = 0; i < child._origText.length; ++i) {
                newText += child._origText[i];
                child.textContent = newText;
                const newHeight = el.clientHeight;

                if (newHeight > height) {
                    lines++;
                    height = newHeight;
                    if (lines > maxLines) {
                        if (newText.length === 1) {
                            child.textContent = '';
                        } else {
                            if (binding.arg == 'ellipsis') {
                                child.textContent = newText.slice(0, newText.length - 5) + '…';
                            } else {
                                child.textContent = newText.slice(0, newText.length - 2);
                            }
                        }
                        return;
                    }
                }
            }
        } else {
            child.style.display = null;

            const newHeight = el.clientHeight;
            if (newHeight > height) {
                lines++;
                height = newHeight;
                if (lines > maxLines) {
                    child.style.display = 'none';
                    break;
                }
            }
        }
    }
}

function setupResizeObserver(el, binding) {
    // Disconnect previous observer if it exists
    if (el._resizeObserver) {
        el._resizeObserver.disconnect();
    }

    const throttledAdjust = throttle(() => {
        if (process.env.NODE_ENV === 'development') {
            console.warn('[DEV] maxLines.js: resizeObserver triggered');
        }
        adjust(el, binding);
    }, 50);

    // Create a resize observer
    const resizeObserver = new ResizeObserver(() => {
        throttledAdjust();
    });

    resizeObserver.observe(el);

    el._resizeObserver = resizeObserver;
}

const maxLinesDirective = {
    mounted(el, binding) {
        adjust(el, binding);
        setupResizeObserver(el, binding);
    },
    updated(el, binding) {
        adjust(el, binding);
    },
    beforeUnmount(el) {
        if (el._resizeObserver) {
            el._resizeObserver.disconnect();
        }
    }
};

export default maxLinesDirective;